import { NgModule } from '@angular/core';
import { CommonModule as AngularCore } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {
  CoreModule, IfFeatureDirective, IfNoFeatureDirective, InlineIconWrapperComponent,
  ModalPanelComponent, PageActionPanelComponent, PostalCodeValidatorDirective,
  StickyPanelBottomComponent,
  StickyPanelBottomContentComponent
} from '@tdwb/core';
import { ConsolidatedAgreementsService, ConsolidatedAgreementsRestService } from '@tdwb/lazy/platform/preferences';
import { WebbrokerCoreModule } from '@tdwb/webbroker/core';
import { CurrentAgreementsModule, OldAgreementsModule } from '../agreements/agreements.module';
import { ConsolidatedAgreementsFormsValidator } from './consolidated-agreements-form/consolidated-agreements-forms-validator.directive';
import { ConsolidatedAgreementsFormComponent } from './consolidated-agreements-form/consolidated-agreements-form.component';
import { ConsolidatedAgreementsModalComponent } from './consolidated-agreements-form/consolidated-agreements.modal.component';
import { ConsolidatedAgreementsTooltipComponent } from './tooltip/consolidated-agreements-tooltip';
import { ConsolidatedAgreementsListComponent } from './consolidated-agreements-form/consolidated-agreements-list.component';

@NgModule({
  imports: [
    AngularCore,
    CoreModule,
    WebbrokerCoreModule,
    TranslateModule.forChild(),
    ModalPanelComponent,
    StickyPanelBottomComponent,
    StickyPanelBottomContentComponent,
    PageActionPanelComponent,
    IfNoFeatureDirective,
    IfFeatureDirective,
    PostalCodeValidatorDirective,
    InlineIconWrapperComponent,
    CurrentAgreementsModule,
    OldAgreementsModule
  ],
  exports: [
    ConsolidatedAgreementsFormComponent,
    ConsolidatedAgreementsFormsValidator,
    ConsolidatedAgreementsTooltipComponent,
    ConsolidatedAgreementsModalComponent,
    ConsolidatedAgreementsListComponent
  ],
  providers: [
    ConsolidatedAgreementsService,
    ConsolidatedAgreementsRestService
  ],
  declarations: [
    ConsolidatedAgreementsFormComponent,
    ConsolidatedAgreementsFormsValidator,
    ConsolidatedAgreementsTooltipComponent,
    ConsolidatedAgreementsModalComponent,
    ConsolidatedAgreementsListComponent
  ]
})
export class PlatformCommonModule {
}

export {
  ConsolidatedAgreementsFormComponent,
  ConsolidatedAgreementsFormsValidator,
  ConsolidatedAgreementsTooltipComponent,
  ConsolidatedAgreementsModalComponent,
  ConsolidatedAgreementsListComponent
};
